<template>
  <div id="app">
    <AppHeader />
    <EntityChoiceModal />
    <router-view />
    <transition name="fade">
      <button
        v-show="showScrollTop"
        class="scroll-top-btn"
        :aria-label="$t('app.scrollToTop')"
        @click="scrollToTop"
      >
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
    </transition>
  </div>
</template>

<script>
import AppHeader from './components/app-header.vue'
import EntityChoiceModal from './components/common/entity-choice-modal.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    EntityChoiceModal
  },
  data() {
    return {
      showScrollTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.showScrollTop = window.scrollY > 300
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style>
@import './style.css';

#app {
  font-family: var(--font-family-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--gray-900);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
</style>
